import React from "react";
import KeyIcon from "../../../icons/KeyIcon";
import TopBorder from "./TopBorder";

const GatedEventCard = ({ className }) => (
  <div
    className={`${className} _lg:tbk-h-75 tbk-relative tbk-overflow-hidden tbk-rounded-2xl tbk-border tbk-border-grey-main tbk-bg-gated-event-card tbk-p-4 tbk-shadow-trube`}
  >
    <TopBorder className="tbk-absolute tbk-left-1/2 tbk-top-0 tbk--translate-x-1/2" />
    <div className="tbk-flex tbk-h-full tbk-flex-col tbk-items-center tbk-justify-center">
      <KeyIcon className="tbk-mb-2" />
      <h2 className="tbk-text-title-medium tbk-mb-2 tbk-text-basic-white">
        Elevated Classes
      </h2>
      <p className="tbk-text-secondary tbk-text-basic-white">
        For members only
      </p>
    </div>
  </div>
);

export default GatedEventCard;
